/**
 * Form Pre-population Handler
 * 
 * Handles form pre-population button clicks to append product title to URL.
 * Works for both Price Match and Product Enquiry forms.
 * Uses event delegation to handle all buttons dynamically, including those
 * rendered after the initial page load.
 * 
 * @fileoverview Global handler for form prepopulation buttons
 */

/**
 * Initializes form pre-population functionality using event delegation
 * This approach ensures all form prepopulation buttons work regardless of when they're rendered
 */
function initializeFormPrepopulation() {
  // Use event delegation on document to catch all clicks
  document.addEventListener('click', function(event) {
    // Check if the clicked element is a form prepopulation button
    const button = event.target.closest('.form-prepopulation-button');
    
    if (!button) return;
    
    const productTitle = button.dataset.productTitle;
    
    if (productTitle && button.href) {
      event.preventDefault();
      
      try {
        const baseUrl = button.href;
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('product', productTitle);
        
        window.location.href = url.toString();
      } catch (error) {
        console.error('Error processing form prepopulation URL:', error);
        // Fallback to original link behavior
        window.location.href = button.href;
      }
    }
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFormPrepopulation);
} else {
  // DOM is already ready
  initializeFormPrepopulation();
}
